import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { ROUTE_PATHS } from 'src/app/app.routes';
import { ButtonComponent } from '@progress/kendo-angular-buttons';
import { NgOptimizedImage } from '@angular/common';

@Component({
  selector: 'app-welcome',
  standalone: true,
  imports: [
    TranslatePipe,
    ButtonComponent,
    NgOptimizedImage
  ],
  templateUrl: './welcome.component.html',
  styleUrl: './welcome.component.scss'
})
export class WelcomeComponent {

  constructor(private router: Router) {
  }

  public start() {
    return this.router.navigate([ROUTE_PATHS.FORM]);
  }

}
